// extracted by mini-css-extract-plugin
module.exports = {"errorMetricsContainer":"monitoringErrorMetrics_errorMetricsContainer__1JlfR","errorMetricCard":"monitoringErrorMetrics_errorMetricCard__2QA7C"};